module.exports = __webpack_public_path__ + "img/scene2-22.f3df63d5.jpg";